//自定义表单表头： 国际化翻译中英对应关系表
export default {
    "数据标题": 'Name',
    "创建人": 'Creator',
    "创建时间": 'Created Time',
    "单据号": 'Sequence No',
    "业务对象": 'Business Object',
    "业务对象ID": 'Business Object ID',
    "创建人部门": 'Dept. ID of Creator',
    "拥有者": 'Owner',
    "拥有者部门": 'Dept.ID of Owner',
    "修改人": 'Modifier',
    "修改时间": 'Modified Time',
    "单据状态": 'Sequence Status',
    "新增": 'Add',
    "删除": 'Delete',
    "导入": 'Import',
    "导出": 'Export',
    "批量修改": 'Batch Edit',
    "批量删除": 'Batch Delete',
    "修改拥有者": 'Modify Owner',
    "批量打印": 'Batch Printing',
    "打印二维码": 'Print QR Code',
    "摘要": 'Summary',
    // 二开 列表页导出弹框中文改成英文
    "流程实例ID": 'Workflow InstanceId',
    "单选框": 'Request Item',
    "createdDeptId": 'Dept. ID of Creator',
    "owner": 'Owner',
    "id": 'Id',
    "name": 'Name',
    "creater": 'Creator',
    "createdTime": 'Created Time',
    "sequenceNo": 'Sequence No',
    "ownerDeptId": 'Dept.ID of Owner',
    "modifier": 'Modifier',
    "modifiedTime": 'Modified Time',
    "workflowInstanceId": 'Workflow InstanceId',
    "sequenceStatus": 'Sequence Status'
    // 二开结束
};
